import React, { FunctionComponent } from 'react'
import { Accordion } from '@afterpaytouch/core'

import styles from './styles.module.css'
import { useDetailedItemViewModel } from './useDetailedItemViewModel'
import { ItemHeader } from './ItemHeader'
import { FinancingSummary } from './components/FinancingSummary'
import { FinancingDetails } from './components/FinancingDetails'

interface ItemProps {
  id: string
  index: number // test purpose
}

export const Item: FunctionComponent<ItemProps> = ({ id, index }) => {
  const { primaryData, childData, primaryAmountPlusChildAmount, schedules, hasInterestAmount, hasDownpayment, isPayInFull, isShippingItem } =
    useDetailedItemViewModel(id)

  if (typeof primaryData === 'undefined' || isShippingItem) {
    return null
  }

  return (
    <li className={styles.item}>
      <Accordion id={`line-item-financing-${id}`} verticalAlignLabel disabled={isPayInFull} caret={isPayInFull ? null : undefined} accessoryPosition={'Bottom'}>
        <Accordion.Button>
          <ItemHeader
            id={id}
            index={index}
            name={primaryData.name}
            price={primaryData.price}
            secondaryPrice={childData?.price}
            strikeThroughPrice={primaryAmountPlusChildAmount}
            showAsterisk={typeof childData !== 'undefined'}
            isPayInFull={isPayInFull}
          />

          <FinancingSummary
            apr={primaryData.apr}
            interestAmount={primaryData.interestAmount}
            monthlyAmount={primaryData.monthlyAmount}
            numberOfInstallments={primaryData.numberOfInstallments ?? schedules.length}
            hasInterestAmount={hasInterestAmount}
            isPayInFull={isPayInFull}
          />
        </Accordion.Button>

        {!isPayInFull && (
          <Accordion.Details>
            <FinancingDetails
              id={id}
              index={index}
              name={primaryData.name}
              schedules={schedules}
              numberOfInstallments={primaryData.numberOfInstallments ?? schedules.length}
              hasDownpayment={hasDownpayment}
              downPaymentAmount={primaryData.downPaymentAmount}
              monthlyAmount={primaryData.monthlyAmount}
              showTradeInDisclaimer={typeof childData !== 'undefined'}
            />
          </Accordion.Details>
        )}
      </Accordion>
    </li>
  )
}
